<template>
  <div class="chart-container" :style="{ height: height + 'px' }">
    <md-progress-spinner :md-diameter="35" :md-stroke="4" md-mode="indeterminate" v-if="isLoading" />
    <bar-component :id="chartId" :ref="refName" :style="chartStyles" :options="chartOptions" :data="chartData" v-else />
  </div>
</template>

<script>
import { Bar as BarComponent } from "vue-chartjs"

export default {
  name: "bar-chart",

  components: { BarComponent },

  props: {
    refName: {
      type: String,
      default: "bar-chart",
    },
    chartData: Object,
    chartOptions: Object,
    height: Number,
    isLoading: Boolean,
    displayLegend: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    chartId() {
      return "bar-chart-" + Math.random()
    },

    chartStyles() {
      return {
        height: `${this.height}px`,
        width: "100%",
      }
    },
  },
}
</script>
